<template>
	<div id="report_admin">
		<div class="row">
			<div class="col-md-6 col-sm-12">
				<div class="form-inline">
					<label class="mr-sm-2" for="datepickerInput">From : </label>
					<datepicker :input-class="'form-control'" :value="fromDate" v-on:selected="onDateChange" style="display: inline-block;"></datepicker>
					<a href="javascript:void(0);" class="btn btn-outline-primary ml-1" @click="getSummary()"><i class="fa fa-refresh"></i></a>
				</div>
				<div class="form-inline">
					<label class="mr-sm-2" for="datepickerInput">To : </label>
					<datepicker :input-class="'form-control'" :value="toDate" v-on:selected="onDateChange2"></datepicker>
				</div>
			</div>
			<div class="col-md-6 col-sm-12 text-right">
				<!-- Rounded switch -->
				<span for="autoRefreshInput" style="vertical-align: top;line-height: 2.2em;">Auto Refresh</span>
				<label class="switch">
					<input type="checkbox" :checked="isAutoRefresh" @change="enableAutoUpdate()">
					<span class="slider round"></span>
				</label>
			</div>
		</div>
		<br>
		<h3 style="color:#3498db">Users</h3>
		<div class="row">

		<div class="col-md-6 col-sm-12">
		<h4>All Users: {{totalusers}} </h4>
		</div>

		<div class="col-md-6 col-sm-12">
		<h4>All Subscriber: {{totalsubscribe}}  </h4>
		</div>

		<div class="col-md-6 col-sm-12">
		<h4>Active User: {{activeusers.total}} (M: {{activeusers.male}} /F: {{activeusers.female}}) </h4>
		</div>
		<div class="col-md-6 col-sm-12">
		<h4>Active Subscriber: {{activesubscribe.total}} (M: {{activesubscribe.male}} /F: {{activesubscribe.female}}) </h4>
		</div>
		<div class="col-md-6 col-sm-12">
		<h4>ทำนายฝา Users: {{activefortuneusers}} </h4>
		</div>
		</div>
		<hr></hr>
		<h3 style="color:#3498db">Messages</h3>
		<h4>Total: {{totalmsg}} msgs</h4>
		<div class="row">
			<div class="col-md-6 col-sm-12">
			<h5>Promotion: {{total_promotion}} msgs</h5>
			</div>
			<div class="col-md-6 col-sm-12">
			<h5>Greeting: {{total_greeting}} msgs</h5>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6 col-sm-12">
			<h5>aboutNeko: {{total_aboutneko}} msgs</h5>
			</div>
			<div class="col-md-6 col-sm-12">
			<h5>PeckOat: {{total_aboutpeckoat}} msgs</h5>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6 col-sm-12">
			<h5>Joke: {{total_joke}} msgs</h5>
			</div>
			<div class="col-md-6 col-sm-12">
			<h5>Negative: {{total_negative}} msgs</h5>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6 col-sm-12">
			<h5>Rude: {{total_rudeword}} msgs</h5>
			</div>
			<div class="col-md-6 col-sm-12">
			<h5>King&Politic: {{total_politic}} msgs</h5>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6 col-sm-12">
			<h5>ทำนายฝา: {{total_fortune}} msgs</h5>
			</div>
			<div class="col-md-6 col-sm-12">
			<h5>Other: {{total_default}} msgs</h5>
			</div>
		</div>

		<hr></hr>
		<div class="form-inline"><h3 style="color:#3498db">Raw Data</h3>
		<a href="javascript:void(0);" class="btn btn-primary" @click="getList()"> View Data</a>
		</div>
		<table class="table table-bordered table-hover">
			<thead>
				<tr class="text-center">
					<th scope="col" width="100">Time</th>
					<th scope="col" width="170">Intent</th>
					<th scope="col" width="170">Intentgroup</th>
					<th scope="col">Message</th>
					<th scope="col" width="170">Report By</th>
					<th scope="col" width="200">Action</th>
				</tr>
			</thead>
			<tbody>




				<reporter-list-item v-for="(report,index) in reporterlist" :key="index" :problemid="report.id" :report="report" :pageid="pageid" @onDelete="deleteReport($event)"></reporter-list-item>
			</tbody>
		</table>
	</div>
</template>

<script>
import axios from 'axios'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'

import config from '@/config'

import reporterItemList from './reporter-list-item'
import reporterAdminInput from './reporter-admin-input'

export default{
	data: function(){
		return {
			reporterlist: [],
			fromDate: '',
			toDate:'',
		    timer: '',
		    isAutoRefresh: true,
		    maxTime : 300000,
			totalmsg: 0,
			total_promotion: 0,
			total_greeting: 0,
			total_aboutneko: 0,
			total_aboutpeckoat: 0,
			total_joke: 0,
			total_negative: 0,
			total_politic: 0,
			total_rudeword: 0,
			total_default: 0,
			total_fortune:0,
			totalusers:0,
			totalsubscribe:0,
			activeusers: {
				total: 0,
				male: 0,
				female : 0
			},
			activesubscribe: {
				total: 0,
				male: 0,
				female : 0
			},
			activefortuneusers :0

		}
	},
	components:{
		'reporter-list-item' : reporterItemList,
		'reporter-admin-input' : reporterAdminInput,
		'datepicker': datepicker
	},
	created: function(){
		this.fromDate = new Date()
		this.toDate = new Date()
		this.getSummary()
		this.timer = setInterval(this.getSummary, this.maxTime)
	},
	computed:{
		pageid: function(){
			return this.$store.state.selectedBot.pageid
		}
	},
	methods:{
		onDateChange: function(date){
			this.fromDate = new Date(date);
			this.getSummary()
		},
		onDateChange2: function(date){
			this.toDate = new Date(date);
			this.getSummary()
		},
		getList: function(){
		let vm = this
		vm.$store.dispatch('loading')
		axios.defaults.headers.common = {
			'AUTHORIZATION': this.$store.getters.securityToken
		};
		axios.get(config.serverUrl + 'problemreportfromto?type=admin&datefrom='+moment(this.fromDate).format('YYYY-MM-DD') + '&dateto='+moment(this.toDate).format('YYYY-MM-DD') +'&pageid='+this.pageid)
			.then(response => {
				// JSON responses are automatically parsed.
				var response = response.data

				this.reporterlist = []; // default

				if (response.responsecode == 200) {
					this.reporterlist =response.data;

				}  else if (response.responsecode == 400){
					let message = response.reason ? response.reason : ''
					var isFacebook = vm.$store.state.isFacebook
					vm.$store.dispatch('logout', { 'error': { 'code': response.responsecode , 'message' : message}})
					
					if (vm.$router.history.current.name != 'login' || vm.$router.history.current.name != 'nigol') {
					
						if (isFacebook) {
							vm.$router.push('/login')
						} else {
							vm.$router.push('/nigol')
						}
				}
				} else {
				}
				vm.$store.dispatch('loading')
			})
			.catch(e => {
				console.error(e)
				// this.errors.push(e)
				vm.$store.dispatch('loading')
			})
		},
		getSummary: function(){
			let vm = this
			vm.$store.dispatch('loading')
			axios.defaults.headers.common = {
				'AUTHORIZATION': this.$store.getters.securityToken
			};
			axios.get(config.serverUrl + 'problemreportsummary?type=admin&datefrom='+moment(this.fromDate).format('YYYY-MM-DD') + '&dateto='+moment(this.toDate).format('YYYY-MM-DD') +'&pageid='+this.pageid)
		    .then(response => {
		      // JSON responses are automatically parsed.
		      var response = response.data

					this.reporterlist = []; // default

					this.totalmsg =0;
					this.total_promotion= 0;
					this.total_greeting= 0;
					this.total_aboutneko= 0;
					this.total_aboutpeckoat= 0;
					this.total_joke= 0;
					this.total_negative= 0;
					this.total_politic= 0;
					this.total_rudeword= 0;
					this.total_default= 0;
					this.total_fortune= 0;
					this.totalusers = 0;
					this.totalsubscribe = 0;

					this.activeusers.total = 0;
					this.activeusers.male = 0;
					this.activeusers.female = 0;

					this.activesubscribe.total = 0;
					this.activesubscribe.male = 0;
					this.activesubscribe.female = 0;
					this.activefortuneusers =0;

		      if (response.responsecode == 200 && response.data.length>=1) {
							var row =response.data[0];

							this.totalmsg =row.totalmsg;
							this.total_promotion= row.promotion;
							this.total_greeting= row.greeting;
							this.total_aboutneko= row.aboutneko;
							this.total_aboutpeckoat= row.aboutpeckoat;
							this.total_joke= row.joke;
							this.total_negative= row.negative;
							this.total_politic= row.politic;
							this.total_rudeword= row.rudeword;
							this.total_default= row.default;
							this.total_fortune= row.fortune;

							this.totalusers = row.totalusers;
							this.totalsubscribe =row.totalsubscribe;

							this.activeusers.total = row.activeusers;
							this.activeusers.male = row.activemale;
							this.activeusers.female = row.activefemale;

							this.activesubscribe.total = row.activesubscribe;
							this.activesubscribe.male = row.activesubscribemale;
							this.activesubscribe.female = row.activesubscribefemale;
							this.activefortuneusers= row.activeusers_fortune;

		      }  else if (response.responsecode == 400){
				let message = response.reason ? response.reason : ''
				var isFacebook = vm.$store.state.isFacebook
				vm.$store.dispatch('logout', { 'error': { 'code': response.responsecode , 'message' : message}})
				
				if (vm.$router.history.current.name != 'login' || vm.$router.history.current.name != 'nigol') {
					
					if (isFacebook) {
						vm.$router.push('/login')
					} else {
						vm.$router.push('/nigol')
					}
				}
			} else {
		      }
		      vm.$store.dispatch('loading')
		    })
		    .catch(e => {
		    	console.error(e)
		      // this.errors.push(e)
		      vm.$store.dispatch('loading')
		    })
		},
		deleteReport: function(payload){
			let vm = this
			const reportIndex = vm.reporterlist.findIndex(report => { return report.id == payload })
			vm.reporterlist.splice(reportIndex,1);
		},
		addReport: function(payload){
			this.reporterlist.unshift(payload)
		},
		enableAutoUpdate: function(){
			this.isAutoRefresh = !this.isAutoRefresh
			if (this.isAutoRefresh) {
				this.timer = setInterval(this.getSummary, this.maxTime)
			} else {
				clearInterval(this.timer)
			}
		}
	},
	beforeDestroy: function() {
		clearInterval(this.timer)
	}
}
</script>

<style>
/* The switch - the box around the slider */
/* .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox *
.switch input {display:none;}

/* The slider *
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders *
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
} */
</style>



// WEBPACK FOOTER //
// src/components/view/template/oishineko/reporter-admin.vue